export { default } from './RateAndAdvantages';
